import {Leaderboard} from "../data/leaderboard";
import {DataView} from "primereact/dataview";
import Sorting from "../data/sorting";
import {Button} from "primereact/button";
import {useNavigate} from "react-router-dom";

function LeaderboardView({leaderboards}: { leaderboards: Leaderboard[] }) {
    const navigate = useNavigate();

    const itemTemplate = (leaderboard: Leaderboard, _: number) => {
        const getSortingIcon = () => {
            switch (leaderboard.sorting) {
                case Sorting.Ascending:
                    return <i className="pi pi-sort-amount-up"></i>;
                case Sorting.Descending:
                    return <i className="pi pi-sort-amount-down"></i>;
                default:
                    return null;
            }
        };

        return (
            <div
                className="flex px-2 align-items-center justify-content-between p-0 w-full">
                <div className="flex align-items-center w-1">
                    {getSortingIcon()}
                </div>
                <div className="flex w-6 overflow-auto">
                    <span className="font-bold  w-full text-overflow-ellipsis overflow-auto">
                        {leaderboard.name}
                    </span>
                </div>
                <div className="flex align-items-end w-6 overflow-auto">
                    <span className="font-bold text-color-secondary text-xs">
                        {leaderboard.id}
                    </span>
                </div>

                <div className="flex gap-2 w-1">
                    <Button
                        icon="pi pi-arrow-right"
                        className="p-button-rounded p-button-text"
                        tooltip="View Entries"
                        onClick={() => {
                            navigate(`/${leaderboard.id}`)
                        }}
                    />
                </div>
            </div>
        );
    };

    const listTemplate = (leaderboards1: Leaderboard[]) => {
        if (!leaderboards1 || leaderboards1.length === 0) return (<div></div>);

        let list = leaderboards1.map((product, index) => {
            return itemTemplate(product, index);
        });

        return <div className="grid grid-nogutter">{list}</div>;
    };

    return (
        <DataView value={leaderboards} listTemplate={listTemplate}></DataView>
    )
}

export default LeaderboardView;